import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { CounsellingTopicVM } from "../models";
import { Injectable } from "@angular/core";
import { ReferenceDataService } from "../services/referencedata.service";


@Injectable()
export class CounsellingTopicResolve implements Resolve<any> {

    constructor(private refService: ReferenceDataService) {
        
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        return new Promise<any>((resolve, reject) => {
            this.refService.getCounsellingTopics().subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
        });

    }

}